import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WHATSAPP_SUPPORT_URL =
  'https://wa.me/916352442321?text=Hi!%20I%20have%20a%20question%20about%20the%20DesignCarat%20STL%20Bundle.';

export default function SupportWidget() {
  const [hovered, setHovered] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();

    // Fire-and-forget lead capture. Never block the WhatsApp redirect.
    try {
      axios
        .post(`${API}/leads`, { source: 'support_widget_click' })
        .catch(() => {});
    } catch (_) {
      // ignore
    }

    // Open support chat in a new tab.
    if (typeof window !== 'undefined') {
      window.open(WHATSAPP_SUPPORT_URL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      data-testid="support-widget"
      className="fixed bottom-24 right-4 sm:bottom-20 sm:right-6 z-50"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Tooltip */}
      <div
        data-testid="support-widget-tooltip"
        aria-hidden={!hovered}
        className={`absolute right-[70px] top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none transition-all duration-200 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-1'
        }`}
      >
        <div
          className="font-body text-xs font-semibold px-3 py-2 rounded-lg text-white"
          style={{
            background: 'rgba(17,17,17,0.92)',
            boxShadow: '0 8px 24px -6px rgba(0,0,0,0.35)',
          }}
        >
          Have a question?
          {/* tooltip caret */}
          <span
            className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 rotate-45"
            style={{ background: 'rgba(17,17,17,0.92)' }}
          />
        </div>
      </div>

      {/* Pulse ring */}
      <span
        className="absolute inset-0 rounded-full pointer-events-none"
        style={{
          background: 'rgba(37,211,102,0.35)',
          animation: 'supportPulse 2.4s ease-out infinite',
        }}
      />

      {/* Button */}
      <button
        type="button"
        onClick={handleClick}
        aria-label="Chat with us on WhatsApp"
        data-testid="support-widget-button"
        className="relative w-14 h-14 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-110 active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#25D366]/50"
        style={{
          background: 'linear-gradient(145deg, #25D366 0%, #1EBE57 100%)',
          boxShadow:
            '0 10px 24px -6px rgba(37,211,102,0.55), 0 4px 10px -2px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.25)',
        }}
      >
        {/* WhatsApp glyph */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-7 h-7"
          aria-hidden="true"
        >
          <path
            fill="#FFFFFF"
            d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.348 0-.646-.19-.646-.19l-3.38-3.382s-.19-.297-.19-.645c0-.43 1.39-1.146 1.39-1.518 0-.372-1.228-3.39-1.6-3.762-.298-.298-.497-.298-.69-.298-.173 0-.372 0-.57.009-.198.01-.517.074-.788.371-.27.297-1.04 1.016-1.04 2.479s1.065 2.876 1.213 3.075c.149.198 2.095 3.33 5.138 4.537 2.533 1.008 3.05.81 3.6.758.55-.05 1.77-.72 2.02-1.415.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347-.297-.149-1.764-.87-2.04-.968-.274-.098-.474-.15-.673.149-.198.297-.57.968-.77 1.126-.19.149-.374.158-.67.009"
          />
          <path
            fill="#FFFFFF"
            fillRule="evenodd"
            d="M15.999 0C7.163 0 .001 7.163.001 16c0 2.817.73 5.464 2.013 7.763L0 32l8.44-2.01A15.923 15.923 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.279 13.279 0 0 1-6.98-1.98l-.5-.297-5.007 1.193 1.212-4.897-.325-.52A13.267 13.267 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667c7.363 0 13.333 5.97 13.333 13.333 0 7.363-5.97 13.333-13.333 13.333z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Scoped pulse animation */}
      <style>{`
        @keyframes supportPulse {
          0% { transform: scale(1); opacity: 0.6; }
          70% { transform: scale(1.6); opacity: 0; }
          100% { transform: scale(1.6); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
